import { ButtonClickEvent } from "./button-click-event";
import { CdpEvent } from "./cdp-event";
import { DecisionsDisplayedEvent } from "./decisions-displayed-event";
import { AlloyResponseDecision, AlloyResponsePropositions } from "./decisions-displayed-event/typeDefinitions";
import { FormEvent } from "./form-event";
import { OneClickPurchaseEvent } from "./one-click-purchase-event";
import { PageErrorEvent } from "./page-error-event";
import { PageLoadStartedEvent } from "./page-load-started-event";
import { PageLoadedEvent } from "./page-loaded-event";
import { ProductLoadedEvent } from "./product-loaded-event";
import { UserDetectedEvent } from "./user-detected-event";
import { VisitorIdEvent } from "./visitor-id-event";
import { WindowLoadStartedEvent } from "./window-load-started-event";
import { WindowLoadedEvent } from "./window-loaded-event";

type DataLayerEvent = ProductLoadedEvent | PageLoadStartedEvent | UserDetectedEvent |
  ButtonClickEvent | FormEvent | OneClickPurchaseEvent | WindowLoadedEvent | DecisionsDisplayedEvent |
  PageErrorEvent | PageLoadedEvent | CdpEvent | WindowLoadStartedEvent | VisitorIdEvent;

export { ButtonClickEvent, CdpEvent, DecisionsDisplayedEvent, FormEvent, OneClickPurchaseEvent, PageErrorEvent, PageLoadedEvent, PageLoadStartedEvent, ProductLoadedEvent, UserDetectedEvent, VisitorIdEvent, WindowLoadedEvent, WindowLoadStartedEvent };
export type { AlloyResponseDecision, AlloyResponsePropositions, DataLayerEvent };

